import {
    GET_COUNTRY_DATA,
    SET_COUNTRY_DATA,
    GET_ALL_STATE_DATA,
    GET_ALL_CITY_DATA,
    GET_ALL_PIN_CODE_DATA,
    SET_ALL_STATE_DATA,
    SET_ALL_CITY_DATA,
    SET_ALL_PIN_CODE_DATA,
    GET_SELECTED_STATE_CITY_DATA,
    SET_SELECTED_STATE_DATA,
    SET_SELECTED_CITY_DATA,
    SET_COUNTRY_REPORT_DATA,
    GET_REPORT_DEALER_DATA,
    SET_REPORT_DEALER_DATA,
    GET_CONTRACTOR_REPORT_DATA,
    SET_CONTRACTOR_REPORT_DATA,
    SET_EXCEL_REPORT,
    GET_EXCEL_REPORT,
    SET_REPORT_VALIDATION,
    GET_REPORT_VALIDATION,
    SET_INTERVAL_ID,
    GET_CERTIFICATE_DATA,
    SET_CERTIFICATE_DATA,
    SET_CERTIFICATE_NAME,
    SEARCH_CERTIFICATE_DATA,
    SET_SEARCH_CERTIFICATE_DATA,
    SET_LOADER_FLAG
} from './types'

export const getReportValidation = (payload) => ({
    type: GET_REPORT_VALIDATION,
    payload,
});

export const setReportValidation = (payload) => ({
    type: SET_REPORT_VALIDATION,
    payload,
});

export const setIntervalId = (payload) => ({
    type: SET_INTERVAL_ID,
    payload,
});

export const getExcelReport = (payload) => ({
    type: GET_EXCEL_REPORT,
    payload,
});

export const setExcelReport = (payload) => ({
    type: SET_EXCEL_REPORT,
    payload,
});

export const getCountryData = (payload) => ({
    type: GET_COUNTRY_DATA,
    payload,
});

export const setCountryData = (payload) => ({
    type: SET_COUNTRY_DATA,
    payload,
});

export const getReportDealer = (payload) => ({
    type: GET_REPORT_DEALER_DATA,
    payload,
});

export const setReportDealer = (payload) => ({
    type: SET_REPORT_DEALER_DATA,
    payload,
});

export const getContractorReport = (payload) => ({
    type: GET_CONTRACTOR_REPORT_DATA,
    payload,
});

export const setContractorReport = (payload) => ({
    type: SET_CONTRACTOR_REPORT_DATA,
    payload,
});

export const getAllStateData = (payload) => ({
    type: GET_ALL_STATE_DATA,
    payload,
});

export const getAllCityData = (payload) => ({
    type: GET_ALL_CITY_DATA,
    payload,
});

export const getAllPinCodeData = (payload) => ({
    type: GET_ALL_PIN_CODE_DATA,
    payload,
});

export const setAllStateData = (payload) => ({
    type: SET_ALL_STATE_DATA,
    payload,
});

export const setAllCityData = (payload) => ({
    type: SET_ALL_CITY_DATA,
    payload,
});


export const setAllPinCodeData = (payload) => ({
    type: SET_ALL_PIN_CODE_DATA,
    payload,
});

export const getStateCityData = (payload) => ({
    payload,
    type: GET_SELECTED_STATE_CITY_DATA,
});

export const setStateData = (payload) => ({
    type: SET_SELECTED_STATE_DATA,
    payload,
});

export const setCityData = (payload) => ({
    type: SET_SELECTED_CITY_DATA,
    payload,
});

export const setCountryReportData = (payload) => ({
    type: SET_COUNTRY_REPORT_DATA,
    payload,
});

export const getCertificateData = (payload) => ({
    type: GET_CERTIFICATE_DATA,
    payload,
})

export const setSearchCertificateData = (payload) => ({
    type: SET_SEARCH_CERTIFICATE_DATA,
    payload,
})

export const setCertificateName = (payload) => ({
    type: SET_CERTIFICATE_NAME,
    payload,
})


export const searchCertificateData = (payload) => ({
    type: SEARCH_CERTIFICATE_DATA,
    payload,
})

export const setCertificateData = (payload) => ({
    type: SET_CERTIFICATE_DATA,
    payload,
})
export const setLoaderFlag = (payload) => ({
    type: SET_LOADER_FLAG,
    payload,
})